import Storage from "@/helpers/storage";

class Auth {
  static setRememberMe(val) {
    Storage.setRememberMe(val);
  }

  static rememberMe() {
    return Storage.rememberMe();
  }

  static token() {
    return Storage.getItem("sessionToken");
  }

  static setToken(token) {
    Storage.setItem("sessionToken", token);
  }

  static name() {
    return Storage.getItem("customerName");
  }

  static setName(name) {
    Storage.setItem("customerName", name || "");
  }

  static formdata() {
    return Storage.getItem("customerFormdata");
  }

  static clearToken() {
    Storage.removeItem("sessionToken");
  }

  static reset(customer) {
    Storage.clear();
    Storage.setItem("sessionToken", customer.attributes.session_token);
  }
}

export default Auth;
